import {view, Icon} from '@sail/ui';
import {warningCircle} from '@sail/icons/react/Icon';
import {Text} from 'src/v2/components/common/Text';
import {useSelector} from 'src/v2/state/store';
import {formatAssetCode} from 'src/v2/util/formatAssetCode';
import {message, useIntl} from '@sail/intl';

const messages = {
  title: message({
    id: 'crypto.payins.v2.any_crypto.quote_error.title',
    description: 'Title for error screen when relay quote cannot be loaded',
    defaultMessage: 'Unable to load payment details',
  }),

  subtitle: message<{
    token: string;
  }>({
    id: 'crypto.payins.v2.any_crypto.quote_error.subtitle',

    description:
      'Subtitle for error screen when relay quote cannot be loaded, includes the asset the user selected',

    defaultMessage:
      "We couldn't load {token} deposit address and quote. Please try again later.",
  }),
};

export const QuoteErrorScreen = () => {
  const intl = useIntl();
  const selectedToken = useSelector(
    (state) => state.anyCryptoDeposit.selectedToken,
  );
  const token = formatAssetCode(selectedToken);

  return (
    <view.div css={{stack: 'y', gap: 'medium'}}>
      <view.div
        css={{
          stack: 'x',
          alignItems: 'center',
          justifyContent: 'center',
          width: 'xxlarge',
          height: 'xxlarge',
          borderRadius: '50%',
          backgroundColor: 'rgba(220, 39, 39, 0.06)',
        }}
      >
        <Icon
          icon={warningCircle}
          css={{
            width: 'space.250',
            height: 'space.250',
            color: 'feedback.critical',
          }}
        />
      </view.div>
      <view.div css={{stack: 'y', gap: 'small'}}>
        <Text type="title" css={{color: 'text'}}>
          {intl.formatMessage(messages.title)}
        </Text>
        <Text type="body" css={{color: 'text'}}>
          {intl.formatMessage(messages.subtitle, {token})}
        </Text>
      </view.div>
    </view.div>
  );
};
